import { render, staticRenderFns } from "./HistoryRecords.vue?vue&type=template&id=7a181904&scoped=true&"
import script from "./HistoryRecords.vue?vue&type=script&lang=js&"
export * from "./HistoryRecords.vue?vue&type=script&lang=js&"
import style0 from "./HistoryRecords.vue?vue&type=style&index=0&id=7a181904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a181904",
  null
  
)

export default component.exports